import { createSlice } from '@reduxjs/toolkit';
import { ApiDashboard } from '../api/models';

export interface DashboardsState {
  dashboards: ApiDashboard[];
}

const initialState: DashboardsState = {
  dashboards: [],
};

const dashboardsSlice = createSlice({
  name: 'dashboards',
  initialState,
  reducers: {
    fetchDashboardsSuccess: (state, action) => {
      state.dashboards = action.payload;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = dashboardsSlice;
// Extract and export each action creator by name
export const { fetchDashboardsSuccess } = actions;
// Export the reducer, either as a default or named export
export default reducer;
